<template>
  <div class="c-action-bar">
    <h3>{{title}}</h3>

    <section class="c-action-bar__content">
      <slot name="content"></slot>
    </section>
  </div>
</template>

<script>
export default {
  name: "ActionBar",
  props: {
    title: {
      type: String,
      default: "Action Required"
    }
  }
};
</script>

<style scoped lang="scss">
.c-action-bar {
    background: rgba(red($colour-nhs-core-blue),green($colour-nhs-core-blue),blue($colour-nhs-core-blue),0.08);
    padding: 20px;
    width: 100%;
    @media (min-width: 768px) {
      padding: 50px;
    }
    display: inline-block;
    position: relative;
    z-index: 1;

    h3 {
        color: $colour-nhs-mid-grey;
        text-transform: uppercase;
        margin-top: 0;
        font-size: 16px;
        line-height: 21px;
    }

    &__content {
        background: white;
        padding: 20px;
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        width: 100%;
    }
}
</style>